import styled from 'styled-components';
import Parent from '../Base/style';
const Wrapper = styled(Parent)`
${({ theme }) => `
font-family: ${theme.palette.tableFont};
`}
`;

export default Wrapper;
